module.exports = __webpack_public_path__ + "img/walk-q4n-1.db3e52c7.png";